import registerPushStateEvent from '../registerPushStateEvent';
import registerReplaceStateEvent from '../registerReplaceStateEvent';

const initializeHistoryApiIntegration = () => {
  registerPushStateEvent();
  registerReplaceStateEvent();
};

export default initializeHistoryApiIntegration;
